import { SubjectTypeModel } from './subjectTypeModel';

export class SubjectTypeViewModel extends SubjectTypeModel{
}
